import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      width: '88vw',
    },
    table: {
      marginTop: 68,
      '& table': {
        borderRadius: 15,
        overflow: 'hidden',
        marginBottom: 30,
      },
      '& thead': {
        background: '#14171A',
        borderRadius: '15px 15px 0px 0px',
      },
      '& thead th': {
        color: '#fff',
        borderBottom: 'none',
      },
      '& thead tr > *': {
        padding: theme.spacing(0.5, 5),
      },
      '& tbody tr > *': {
        padding: theme.spacing(0.5, 5),
      },
      '& tbody tr:nth-of-type(odd) ': {
        background: '#fff',
        cursor: 'pointer',
      },
      '& tbody tr:nth-of-type(even)': {
        background: '#F5F8FA',
        cursor: 'pointer',
      },
      '& td': {
        borderBottom: 'none',
      },
    },
    contentDate: {
      fontSize: 12,
      margin: '12px 0',
    },
    title: {
      margin: '12px 0',
    },
    contentRecipient: {
      display: 'flex',
      alignItems: 'center',
      height: 32,
      background: ' #F5F8FA',
      borderRadius: 16,
      margin: '0px 8px 0px 8px',
    },
    contentArrayRecipient: {
      display: 'grid',
      alignItems: 'center',
      height: 112,
      borderRadius: 8,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      padding: '12px 8px',
      gridTemplateRows: '0.1fr 1fr',
      '&::-webkit-scrollbar': {
        height: 6,
        width: 8.5,
      },
      '&::-webkit-scrollbar-thumb': {
        background: 'rgba(170, 184, 194, 0.8);',
        borderRadius: 15,
      },
      // overflow: 'auto !important',
      scrollbarWidth: 'thin',
      msOverflowStyle: 'auto',
    },
    recipient: {
      fontSize: 12,
      whiteSpace: 'nowrap',
    },
    contentImage: {
      width: 20,
      height: 20,
      background: '#E1E8ED',
      borderRadius: 20,
      margin: '0px 8px',
    },
    contentFilters: {
      display: 'flex',
      alignItems: 'center',
      border: '1px solid #E1E8ED',
      borderRadius: 8,
      padding: '0 16px 0 8px',
    },
  }),
);

export default useStyles;
